export default "__VITE_ASSET__ee55353b__"